import styled from '@emotion/styled'

export const AccessTokensTableWrapper = styled.div`
  width: 100%;
`
